import Hero from "../components/Hero";
import Navbar from "../components/Navbar"
import RiverImg from "../assets/PlaceHolder/2.jpg"
import Footer from "../components/Footer"
import ContactForm from "../components/ContactForm"
import thumb from "../assets/thumb/inga-engele-CCFWTMnRWsE-unsplash.jpg";


function Contact (){
    return(
        <>
        <Navbar/>
        <Hero 
        cName="hero-mid" 
        heroImg={thumb} 
        title="CONTACT US"
        btnClass="hide"/>
        <ContactForm/>
        <Footer/>
        </>
        
    );
}

export default Contact;